import { concat, unionBy } from 'lodash'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { TagPicker as Component } from 'ui-components'
import { getSearchQuery } from 'utils'
import { useTags } from '~map-search/hooks/useTags'
import { useSearchTagsQuery } from '~map-search/services/tag'

const TagPicker = (props) => {
  const router = useRouter()
  const value = useTags()
  const [selectedOptions, setSelectedOptions] = useState([])

  const [inputValue, setInputValue] = useState('')

  const { options = [] } = useSearchTagsQuery(
    {
      query: inputValue
    },
    {
      refetchOnMountOrArgChange: true,
      selectFromResult: ({ data }) => {
        return {
          options: unionBy(
            concat(selectedOptions, data?.searchTags || []),
            'id'
          )
        }
      }
    }
  )

  const handleChange = (event, tags) => {
    setSelectedOptions(tags)

    const tagIds = tags.map((tag) => tag?.id)

    router.push(
      getSearchQuery({
        tags: tagIds
      })
    )

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    })
  }

  const handleInputChange = (event, value) => {
    setInputValue(value)
  }

  return (
    <Component
      {...props}
      options={options}
      value={value}
      inputValue={inputValue}
      onChange={handleChange}
      onInputChange={handleInputChange}
    />
  )
}

export { TagPicker }
